import { ChangeDetectionStrategy, Component, computed, input, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { UI } from '../ui';
import { ChipMultiSelectComponent } from './chip-multi-select.component';
import { ALL_SCOPES, type Option } from './merchant-config.models';

/** Operation scope selection: "all scopes" switch, or searchable chips for individual scopes. */
@Component({
  selector: 'mm-scope-picker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ChipMultiSelectComponent, ...UI],
  template: `
    <ui-switch [checked]="all()" [disabled]="disabled()" (changed)="setAll($event)">
      All scopes<span description>Full API access for this application.</span>
    </ui-switch>
    @if (!all()) {
      <input uiInput type="search" class="my-3 w-full max-w-sm" placeholder="Search scopes…"
        aria-label="Search scopes" [ngModel]="query()" (ngModelChange)="query.set($event)" />
      <mm-chip-multi-select label="Scopes" [options]="visible()" [disabled]="disabled()"
        [value]="value()" (valueChange)="value.set($event)" />
      @if (!value().length) {
        <p class="mt-2 text-xs text-muted">No scope selected: the application has no API access.</p>
      }
    }
  `,
})
export class ScopePickerComponent {
  readonly choices = input.required<readonly Option[]>();
  readonly value = model<string[]>([]);
  readonly disabled = input(false);

  readonly query = signal('');
  readonly all = computed(() => this.value().includes(ALL_SCOPES));
  readonly visible = computed(() => {
    const term = this.query().trim().toLowerCase();
    const selected = new Set(this.value());
    return this.choices().filter(
      (c) => c.value !== ALL_SCOPES && (selected.has(c.value) || !term || c.label.toLowerCase().includes(term) || c.value.toLowerCase().includes(term)),
    );
  });

  setAll(on: boolean): void {
    this.value.set(on ? [ALL_SCOPES] : []);
  }
}
